/**
 * Copyright(c) 2024 Magrabi
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information of Magrabi ("Confidential
 * Information"). You shall not disclose such Confidential Information and shall use it only in
 * accordance with the terms of the contract agreement you entered into with Magrabi.
 *
 * @module Cookies
 *
 * @author Naseef O
 */

"use server";

import { cookies } from "../apiUtils/cookieBaseUtils";

/**
 * @description This function is used to create a cookie
 *
 * @export
 * @param {string} key
 * @param {*} value
 */
export async function createCookie(key: string, value: any, options: any = {}) {
  cookies()?.set(key, value.toString(), options);
}

/**
 * @description This function is used to delete a cookie
 *
 * @export
 * @param {string} key
 */
export async function deleteCookie(key: string) {
  // cookies()?.set(key, ""); changing this to delete to avoid key persisting
  cookies()?.delete(key);
}

/**
 * @description This function is used to get a cookie
 *
 * @export
 * @param {string} key
 * @return {*}  {Promise<any>}
 */
export async function getCookie(key: string): Promise<any> {
  return cookies()?.get(key)?.value;
}
